/* @ngInject */
export function RubricTextController ($scope, $translate) {
	$scope.getTextAriaIndex = function () {
		const textIndex = ($scope.schema?.elements || [])
			.filter((item) => item.type === 'text')
			.indexOf($scope.element);

		return textIndex >= 0 ? textIndex + 1 : null;
	};

	$scope.getTextTitleAriaLabel = function () {
		const textIndex = $scope.getTextAriaIndex();
		const label = $scope.element.title || $translate.instant('rubric_aria-text-item-title');
		return textIndex != null ? `${label} ${textIndex}` : label;
	};

	$scope.getTextDescriptionAriaLabel = function () {
		const textIndex = $scope.getTextAriaIndex();
		const label = $scope.element.desc || $translate.instant('rubric_aria-text-item-description');
		return textIndex != null ? `${label} ${textIndex}` : label;
	};
}
